import React from 'react';
import {Form, message, Input, Select, Button, Radio,Checkbox, Table, Modal} from 'antd';
//import {GetOccupation} from "../../api/api"
import {FormattedMessage} from 'react-intl';
import {connect} from "react-redux";
import actions from "../../store/actions";
import {conuntry} from "./country";

const Option = Select.Option;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;

class RegistrationForm extends React.Component {
    state = {
        visible: false,
        disabled: true,
        data: [],
        value: 1,
        OccupationObj: {},
        date: [],
        historyDate: {},
        dataSource: [{
            key: 0,
            Nationality: "",
            OrganizationName: "",
            TitlePosition: "",
            VisitorsNum: "",
        }],
        phonePattern:/^\d+$/,
        checked:true
    }

    /*上一步按钮*/
    handleBack = (e) => {
        e.preventDefault();
        let info = {
            cleanVis: false,
        }
        this.props.Clean(info);
        this.props.history.push("/Activities2");

    };
    /*下一步按钮*/
    handleNext = (e) => {
        e.preventDefault();
        if(this.state.checked!==true){
            message.info(this.props.local==='zh'?"请同意联想隐私协议":"Please continue to agree to the privacy policy.");
            return;
        }
        this.props.form.validateFieldsAndScroll((err, values) => {
            console.log(values);
           // if (values.radioA === 1 && values.radioB === 2
             //   && values.radioC === 3 && values.radioD === 4) {
                let info = {
                    ...values, dataSource: this.state.dataSource,OccupationObj:this.state.OccupationObj};
                if (!err) {
                    this.props.addValue3(info);
               /*     localStorage.setItem("addValue3", values,);*/
                    this.props.history.push("/Activities5");
                   // window.scrollTo(300, 350);
                }
           // } else {
            //    message.warning('you do not agree to all,please re-select !!');
           // }

        });

    };

    /*获取后台数据*/
    componentWillMount() {
        /*临时存储*/
        let cleanValue = this.props.cleanValue;
        if(!this.props.Activities1||!this.props.Activities1.value){
            this.props.history.push('/Group');
            return;
        }
        if(!this.props.Activities2||!this.props.Activities2.value){
            this.props.history.push('/Activities2');
            return;
        }
        if (cleanValue.cleanVis === true) {
            this.setState({
                historyDate: {}
            })
        } else {
            const {value} = this.props;
            if (value !== "") {
                this.setState({
                    dataSource: value.dataSource,
                    OccupationObj:value.OccupationObj,
                })
            }
            let history = this.props.value;
            if (history !== undefined || history !== '') {
                this.setState({
                    historyDate: {
                        Name: history.Name,
                        MobilePhone: history.MobilePhone,
                        EMail: history.EMail,
                        Nationality: history.Nationality,
                        InterestTopic: history.InterestTopic,
                        radioA: history.radioA,
                        radioB: history.radioB,
                        radioC: history.radioC,
                        radioD: history.radioD,
                    }
                })
            }
        }


        /*后台数据*/
        // GetOccupation().then((response) => {
        //     let data = response.DataResult;
        //     this.setState({
        //         data: data
        //     });

        // }).catch((error) => {
        //     console.log(error);
        // });

    }


    /*删除*/
    handleDelete = (key) => {
        if (key <= 0) {
            message.info("至少需要有一条数据");
            return
        }
        const dataSource = this.state.dataSource;
        let newDateSource = dataSource.filter((item, index) => {

                return item.key !== Number(key)

        });
        this.setState({
            dataSource: newDateSource
        })
    }
    /*增加*/
    handleAdd = () => {
        const {dataSource} = this.state;
        let key = dataSource.length + 1;
        const newData = {
            key: key,
            Nationality: "",
            OrganizationName: "",
            TitlePosition: "",
            VisitorsNum: ""
        };
        this.setState({
            dataSource: [...dataSource, newData],
        });
    };
    /*关闭模态框*/
    updateDataSource = (dataSource) => {
        this.setState({
            dataSource: dataSource
        })
    }
    /*模态框出现*/
    showModal = () => {
        this.setState({
            visible: true,
        });
    }
    /*确定模态框*/
    handleOk = (e) => {
        console.log(e);
        this.setState({
            visible: false,
        });
    }
    /*取消模态框*/
    handleCancel = (e) => {
        console.log(e);
        this.setState({
            visible: false,
        });
    }
    handleBack12 = (value) => {
        // let OccupationObj = this.state.OccupationObj;
        // this.state.data.forEach((item) => {
        //     if (item.Value === value.item.props.eventKey) {
        //         OccupationObj.Value = item.Value;
        //         OccupationObj.ValueNameEN = item.ValueNameEN;
        //         OccupationObj.ValueNameCN = item.ValueNameCN;
        //     }
        //     this.setState({
        //         Occupation: OccupationObj
        //     })
        // })
    };
    checkChange(checked){
        this.setState({
            checked:checked
        });
    }
    openxy(){
        console.log(111);
       this.setState({
        visible:true
       });
    }
    render() {
        console.log(this.props.local);
         //let opertor=this.props.local!=='zh'?'Operation':'操作'; 
        const {getFieldDecorator} = this.props.form;
        const {historyDate} = this.state;
        const {dataSource} = this.state;
        const addInfo = (e, name, key) => {
            const {getFieldValue,} = this.props.form;
            const {dataSource} = this.state;
            dataSource.forEach((item) => {
                    if (item.key ===Number(key)) {
                        switch(name) {
                            case 'Nationality':
                                const Nationality = getFieldValue(`Nationality${key}`);
                                item.Nationality = Nationality;
                                break;
                            case'OrganizationName':
                                const NameOrganization = getFieldValue(`OrganizationName${key}`);
                                item.OrganizationName = NameOrganization;
                                break;
                            case 'TitlePosition':
                                const TitlePosition = getFieldValue(`TitlePosition${key}`);
                                item.TitlePosition = TitlePosition;
                                break;
                            case 'VisitorsNum':
                                const NoOfVisitors = getFieldValue(`VisitorsNum${key}`);
                                item.VisitorsNum = NoOfVisitors;
                                break;
                        }
                    }
                }
            );
            this.updateDataSource(dataSource)
        };

        const columns = [
            {
                title: 'Nationality',
                dataIndex: 'Nationality',
                width: '10%',
                render: (text, record) => {
                    let Nationality = record.Nationality;
                    return (
                        getFieldDecorator(`Nationality${record.key}`, {
                            initialValue: Nationality,
                        })(
                            <input  onBlur={(e) => addInfo(e, 'Nationality', `${record.key}`)}/>
                        )
                    )
                }
            }, {
                title: 'Name of Organization',
                dataIndex: 'OrganizationName',
                width: '10%',
                required: true,
                render: (text, record) => {
                    let NameOfOrganization = record.OrganizationName;
                    return (
                        getFieldDecorator(`OrganizationName${record.key}`, {
                            initialValue: NameOfOrganization,
                        })(
                            <input onBlur={(e) => addInfo(e, 'OrganizationName', `${record.key}`)}/>
                        )
                    )
                }
            }, {
                title: 'Title / Position',
                dataIndex: 'TitlePosition',
                width: '10%',
                render: (text, record) => {
                    let TitlePosition = record.TitlePosition;
                    return (
                        getFieldDecorator(`TitlePosition${record.key}`, {
                            initialValue: TitlePosition,
                        })(
                            <input onBlur={(e) => addInfo(e, 'TitlePosition', `${record.key}`)}/>
                        )
                    )
                }
            }, {
                title: 'No. of Visitors',
                dataIndex: 'VisitorsNum',
                width: '10%',
                render: (text, record) => {
                    let VisitorsNum = record.VisitorsNum;
                    return (
                        getFieldDecorator(`VisitorsNum${record.key}`, {
                            initialValue: VisitorsNum,
                        })(
                            <input onBlur={(e) => addInfo(e, 'VisitorsNum', `${record.key}`)}/>
                        )
                    )
                }
            }, {
                title: "Operation",
                dataIndex: 'opertor',
                key: 'opertor',
                width: '10%',
                render: (text, record) => {
                    return (<div style={{width: "100px", height: "10px"}}>
                            <span onClick={this.handleAdd} style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                marginRight: "20px",
                                cursor: "pointer"
                            }}> + </span>
                        <span style={{
                            fontSize: "20px",
                            fontWeight: "bold",
                            marginLeft: "20px",
                            marginBottom: "20px",
                            cursor: "pointer"
                        }}
                              onClick={() => this.handleDelete(`${record.key}`)}> - </span>
                    </div>)

                }
            }
        ];
        const columns1 = [
            {
                title: '国籍',
                dataIndex: 'Nationality',
                width: '10%',
                render: (text, record) => {
                    let Nationality = record.Nationality;
                    return (
                        getFieldDecorator(`Nationality${record.key}`, {
                            initialValue: Nationality,
                            rules: [{required: true, message: 'Please input your text!', whitespace: true}],
                        })(
                            <input onBlur={(e) => addInfo(e, 'Nationality', `${record.key}`)}/>
                        )
                    )
                }
            }, {
                title: '来宾单位',
                dataIndex: 'OrganizationName',
                width: '10%',
                required: true,
                render: (text, record) => {
                    let NameOfOrganization = record.OrganizationName;
                    return (
                        getFieldDecorator(`OrganizationName${record.key}`, {
                            initialValue: NameOfOrganization,
                            rules: [{required: true, message: 'Please input your text!', whitespace: true}],
                        })(
                            <input onBlur={(e) => addInfo(e, 'OrganizationName', `${record.key}`)}/>
                        )
                    )
                }
            }, {
                title: '职位',
                dataIndex: 'TitlePosition',
                width: '10%',
                render: (text, record) => {
                    let TitlePosition = record.TitlePosition;
                    return (
                        getFieldDecorator(`TitlePosition${record.key}`, {
                            initialValue: TitlePosition,
                            rules: [{required: true, message: 'Please input your text!', whitespace: true}],
                        })(
                            <input onBlur={(e) => addInfo(e, 'TitlePosition', `${record.key}`)}/>
                        )
                    )
                }
            }, {
                title: '人数',
                dataIndex: 'VisitorsNum',
                width: '10%',
                render: (text, record) => {
                    let VisitorsNum = record.VisitorsNum;
                    return (
                        getFieldDecorator(`VisitorsNum${record.key}`, {
                            initialValue: VisitorsNum,
                            rules: [{required: true, message: 'Please input your text!', whitespace: true}],
                        })(
                            <input onBlur={(e) => addInfo(e, 'VisitorsNum', `${record.key}`)}/>
                        )
                    )
                }
            }, {
                title: '操作',
                dataIndex: 'opertor',
                key: 'opertor',
                width: '5%',
                render: (text, record) => {
                    return (<div style={{width: "50px", height: "10px"}}>
                            <span onClick={this.handleAdd} style={{
                                fontSize: "20px",
                                fontWeight: "bold",
                                marginRight: "20px",
                                cursor: "pointer"
                            }}> + </span>
                        <span style={{
                            fontSize: "20px",
                            fontWeight: "bold",
                            marginLeft: "20px",
                            marginBottom: "20px",
                            cursor: "pointer"
                        }}
                              onClick={() => this.handleDelete(`${record.key}`)}> - </span>
                    </div>)

                }
            }
        ];

        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 8},
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 16},
            },
        };
        const formItemLayoutA = {
            labelCol: {span: 6},
            wrapperCol: {span: 14},
        };
        const radioStyle = {
            height: '30px',
            lineHeight: '30px',
        };
      


        return (<Form onSubmit={this.handleSubmit}>
                {/*名字*/}
                <FormItem
                    {...formItemLayout}
                    label={<FormattedMessage
                        id="intl-Activities3-name"
                    />}
                    help=""
                >
                    {getFieldDecorator('Name', {
                        initialValue: historyDate && historyDate.Name,
                        rules: [{required: true, message: this.props.local==='zh'?'请输入您的姓名！':'Please input your name!', whitespace: true}],
                    })(
                        <Input style={{width: "300px"}}/>
                    )}
                </FormItem>
                {/*国籍*/}
                <FormItem
                    {...formItemLayout}
                    label={<FormattedMessage
                        id="intl-Activities3-Nationality"
                    />}
                    help=""
                >
                    {getFieldDecorator('Nationality', {
                        initialValue: historyDate && historyDate.Nationality,
                        rules: [{
                            required: true, message: this.props.local==='zh'?'请输入您的国籍！':'Please confirm your Nationality!',
                        }],
                    })(
                        <Select
                            showSearch
                            style={{width: 300}}
                            onChange={(value)=>{
                                if(value==="China"){
                                    this.setState({
                                        phonePattern:/^\d{11}$/
                                    })
                                    //清空mobile
                                   // this.props.form.setFields({"MobilePhone":""})
                                }else{
                                    this.setState({
                                        phonePattern:/^\d+$/
                                    })
                                }
                                this.props.form.setFields({"MobilePhone":""})
                                //
                                // var bbb =document.querySelector('#MobilePhone');
                                // if (bbb.fireEvent){
                                //     bbb.fireEvent('onchange');
                                // }
                                // else{
                                //    var ev = document.createEvent("HTMLEvents");  
                                //     ev.initEvent("change", false, true);  
                                //     bbb.dispatchEvent(ev);  
                                // }
                           
                                
                            }}
                        >
                            {conuntry.data.map((item) => {
                                return <Option  key={item.Id}  value={item.title}>
                                    {item.title}
                                </Option>
                            })}
                        </Select>,
                    )}
                </FormItem>
                  {/*邮箱*/}
                  <FormItem
                    {...formItemLayout}
                    label={<FormattedMessage
                        id="intl-Activities3-E-mail"
                    />}
                    help=""
                >
                    {getFieldDecorator('EMail', {
                        initialValue: historyDate && historyDate.EMail,
                        rules: [{
                            type: 'email', message: 'The input is not valid E-mail!',
                        }, {
                            required: true, message: 'Please input your E-mail!',
                        }],
                    })(
                        <Input style={{width: '300px'}}/>
                    )}
                </FormItem>
                {/*手机*/}
                <FormItem
                    {...formItemLayout}
                    label={<FormattedMessage
                        id="intl-Activities3-phone"
                    />}
                    help=""
                >
                    {getFieldDecorator('MobilePhone', {
                        initialValue: historyDate && historyDate.MobilePhone,
                        rules: [{ pattern:this.state.phonePattern,required: true, message: 'Please input your phone number!', }],

                    })(
                        <Input style={{width: '300px'}} />
                    )}
                </FormItem>
              
              
                {/* <h4 className="applyTitle"><FormattedMessage id="intl-VisitorsInfo"/></h4> */}
                {/* <Table
                    bordered
                    dataSource={dataSource}
                    columns={this.props.local === "en" ? columns : columns1}
                /> */}
               

                {/*单选框*/}
                {/* <div className="applyForm-radio"> */}
                <Modal
                                title="声明"
                                visible={this.state.visible}
                                onOk={this.handleOk}
                                width={500}
                                onCancel={this.handleCancel}
                                footer={<div><Button onClick={this.handleCancel.bind(this)} type="primary">确认</Button></div>}
                            >
                            <div className="lenovo_xycontent">
                               <h6>本隐私声明最后更新于2018年5月2日。</h6>
                        <div className="line3">一、关于本声明</div>
                        <div className="line6"><ul><li><strong>本声明适用范围。</strong>联想重视您的隐私。本隐私声明适用于由联想集团及其附属公司（“联想”或“我们”）拥有和运营的网站。本政策介绍联想网站（例如https://www.lenovo.com.cn/）的信息做法，包括收集何种信息、如何使用此类信息、与谁分享此类信息及如何保护此类信息。</li><li><strong>本声明不适用范围。</strong>联想网站可能含有指向其他网站的链接。联想对这些其他网站的隐私做法或内容不承担任何责任。另请注意，本声明不适用于通过联想的产品和软件以及通过一些其他来源收集的信息。要了解更多有关我们的产品和软件隐私做法的信息，请访问【<a href="https://shop.lenovo.com.cn/investor/html/productPrivacy.html">联想产品隐私声明</a>】。</li><li><strong>本声明的变更。</strong>如果我们对本声明作出更改，我们会应要求提供先前版本以便您了解更改的时间和内容。如果我们对本声明作出任何重大更改，会在该等更改生效之前通过在本网站发出通知或者发送电子邮件（发送至您帐户所指明的电子邮件地址）的方式告知您。在适用数据保护法律的要求下，我们亦会就任何影响我们如何使用您个人信息的重大变更寻求您的同意。我们建议您定期查看本页面，以了解有关我们隐私做法的最新信息。 本声明将会帮助您了解以下内容：<ul><li>联想通过其网站会收集哪些信息</li><li>联想如何使用和分享通过其网站收集的信息；</li><li>个人信息的存储地点；</li><li>cookie、网络信标和相关技术；</li><li>个人信息保存时限；</li><li>个人信息安全；</li><li>儿童隐私保护；</li><li>您的数据控制权；</li><li>本隐私声明的更新；以及</li><li>联系我们。</li></ul>联想深知个人信息对您的重要性，并会尽力保护您的个人信息安全可靠。 请在使用我们的产品（或服务）前，仔细阅读并了解本《隐私政策》。</li></ul></div>
                        <div className="line3">二、联想通过其网站会收集哪些信息？</div><div className="line8"><ul><li>联想会向其网站访客收集下列信息：</li><li><strong>您自愿提供给我们的信息。</strong>通常，您访问联想网站时无需告知我们您是谁，亦无需提供任何可直接识别您自己的个人信息。但是，有时候我们（或者为我们工作的供应商）可能需要您的信息。在许多情况下，您可以选择将个人信息提供给我们。例如，您注册账户登录我们的网站时，我们可能会收集您的个人信息，例如手机号或其他网络平台的账号；或者，在您向联想下订单的时候，我们可能会收集您的个人信息，例如姓名、地址、电子邮件地址、电话号码、支付信息（包括电子支付账户信息、支付卡信息等）、用于个性化联想产品或软件体验的信息、社会保险号（或等同的身份证号码）、出生日期以及您选择提供的其它信息。联想使用此类信息方便订单处理以及使我们能够在您的订单出现问题时与您联系。另外，如果您购买需要服务的产品，必要时可能会使用您的个人信息来获取信用报告。请注意，如果在我们提出要求时您没有将个人信息提供给我们，我们可能无法为您提供您所申请的产品或服务。若您为他人购买联想产品，我们可能会收集有关主体的上述个人信息，用于处理其订单以及在订单出现问题时与其联系，您理解并确认您在提供上述他人个人信息时，已经获得了有关主体的授权或同意，我们只会将其个人信息用于提供联想的产品及服务，不会另作其他用途。 在包括以下场合的其他场合中，包括我们可能会要求您提供个人信息并会收集个人信息：在您参加抽奖、竞赛或其他促销时；在您订阅接收联想或联想营销通讯或时事通讯时；在您完成调查时；或者在贸易展览、会议或类似活动中您与联想或联想互动时。我们使用您提供的信息来帮助我们设计和改善我们的网站和产品、定制您的在线体验、提供建议和购买推荐以及用于与本政策相符的其他用途。 在您参与用户论坛或博客时，可能会与使用该服务的所有用户公开分享您的相关信息，例如，您照片及其他个人信息、您对其他人上传或发布的信息作出的回应等。 联想还基于用户在购买产品或服务时、促销期间提供给我们的信息以及来自调查和我们的服务器日志文件的信息对我们的用户的人口特征（例如年龄和性别）、兴趣和行为开展调查。我们这样做的目的是为了更好地了解您并为您提供服务。此类调查将以汇总的方式进行整理和分析，以防止识别与任何个人相关的个人信息。联想可能会与我们的供应商分享这些汇总数据。 最后，在您通过我们的网站提交申请表示您对联想或联想的就业机会有兴趣时，我们可能会要求您提供您的个人信息。在您提交申请时将会告知您我们向您收集的信息，并且我们只会将此类信息用于评估您的应聘候选资格。</li><li><strong>我们自动收集的信息。</strong>我们的网络服务器日志会自动收集访客的域名和特定相关数据（例如他们的 IP 地址或设备标识符）。此类信息不会直接识别我们的访客，仅用于衡量访问数量、在联想网站上所花的平均时间、所查看的页面以及网站使用信息。我们使用此类信息来满足法律或监管要求；衡量我们的网站使用情况；改善我们的网站内容；以及提供定制的广告。此类信息不会以能够直接识别任何访客身份的形式使用。我们可能会使用 cookie 来收集此类信息，如下文cookie、网络信标、分析和相关技术一节中所述。</li><li><strong>我们从其他来源收集的信息。</strong>有有时我们可能会用来自其他来源的信息（例如，您访问我们的专柜时线下提供的信息、您向我们的合作伙伴提供并同意分享给联想的信息等）来补充您通过联想网站向我们提供的信息，例如用于验证您的地址的信息或者有关业务的其他可用信息。这是为了帮助我们维持所收集信息的准确性以及帮助我们提供更好的服务。</li></ul></div>
                        <div className="line3">三、联想如何使用和分享其收集的信息？</div>
                        <div className="line6"><ul><li>下列各节更详细地介绍联想可能会如何使用您的个人信息以及我们可能会与谁分享您的个人信息。根据您所访问的联想网站类型，以下内容中的一节或多节可能适用。</li><li>为本声明所述之目的，我们可能会与为联想提供服务的签约供应商、业务合作伙伴及关联公司分享前述关于您自愿提供或我们主动收集的您的个人信息。在某些情况下，联想使用供应商来收集、使用、分析以及以其他方式代为处理信息。联想的做法是要求这些供应商或业务合作伙伴以符合我们的政策的方式处理信息。</li><li>我们会在如下情况使用和分享您的个人信息:</li><li><strong>在您注册Lenovo ID的时候。</strong>如果您希望使用我们的服务或购买我们的产品，您需要注册Lenovo ID，我们会收集您的手机号、社交账号或其他个人信息以完成您的账号注册。</li><li><strong>在您请求或订购物品的时候。</strong>如果您在联想网站上请求或订购物品，例如产品或服务、要求回电或者提供特定的营销材料，我们会使用您提供的信息来满足您的请求。为了帮助我们满足您的请求，我们可能会与其他人分享信息，例如在满足您的请求过程中涉及的联想和联想的其他部门、联想和联想的服务提供商、供货商、供应商、金融机构、货运公司、邮政或政府当局（如海关）。与交易相关时，我们还可能会出于客户满意度调查或市场研究目的与您联系。若要退出调查及/或市场研究通讯，请参见下文标题为“营销”的小节。</li><li><strong>Lenovo ID 和产品注册。</strong>当您创建一个Lenovo ID 或者注册联想或联想产品时，我们将收集有关您的Lenovo ID信息或与您的联想设备相关的信息，包括个人信息。除Lenovo ID信息 外，我们还可能会要求您提供您的姓名、电子邮件地址、语言及地区/国家、设备类型/型号、IP 地址、设备序列号、设备注册日期以及有关您的操作系统的任何激活数据用于帮助您完成产品注册或激活。</li><li>当您使用我们的在线服务时，如我们的网上商店及客户支持网站，我们将使用您的Lenovo ID 来识别您的身份。如果您希望停用您的Lenovo ID，可随时联系 【privacy@lenovo.com】。</li><li><strong>营销。</strong>联想及指定供应商或合作伙伴也可能会将您在某些联想网站上提供的信息用于营销目的，例如在您订阅接收营销通讯或时事通讯时，或者在您参加抽奖、竞赛或促销时。在我们收集此类信息之前，您将有机会选择是否同意以上述方式使用您的信息。您可通过遵循相关通讯内的取消订阅说明、访问帐户设置页面内的营销或联系偏好或者联系我们【privacy@lenovo.com】，选择停止接收我们的营销通讯。</li><li><strong>客户感言。</strong>联想有时会在我们的网站上展示满意客户的产品评述、客户感言和其他代言。经您同意，我们可能会连同您的姓名或Lenovo ID公布您的评论。如果您想更新或删除您的评论，可以通过【privacy@lenovo.com】联系我们。</li><li><strong>服务质量监控。</strong>某些网站活动也可能会涉及您打电话给联想或其售后服务提供商，或者他们打电话给您。请注意，在某些情况下，出于员工培训和质量保证目的，我们可能会对通话录音并保存。</li><li><strong>业务合作伙伴关系。</strong>如果您是代表联想的业务合作伙伴（即联想产品的分销商或经销商），您可以访问专门面向联想业务合作伙伴的联想网站。我们可能会使用在该网站上提供的个人信息来管理和发展我们与您以及您所代表的公司的业务关系。例如，我们可能会通过您的联系方式向您发送联想业务合作伙伴计划的详情或将您的某些个人信息与其他业务合作伙伴（受制于可能存在的任何保密义务）或者联想客户或潜在客户分享。与特定交易或计划相关时，我们还可能会出于客户满意度调查或市场研究目的与您联系。</li><li><strong>供应商管理。</strong>如果您是联想的供应商，您可以访问专门面向联想供应商的联想网站。我们可能会在与您达成或履行交易时使用在该网站上提供的信息。例如，这可能包括与在完成交易所涉及的联想的其它部门、联想的业务合作伙伴、客户、货运公司、金融机构、邮政或政府当局分享信息。信息还可能会被用于管理和发展我们与您、您所代表的供应商及/或其它联想供应商的关系。</li><li><strong>法律要求的披露。</strong>在某些情况下，政府机关或者法院可能会要求联想提供您的个人信息。在这种情况下，我们会根据法律要求向政府机构或法院披露个人信息或其他信息，以保护我们的权利、您的安全或其他人的安全、对欺诈行为进行调查，或对政府的要求做出回应。 行调查，或对政府的要求做出回应。</li><li><strong>博客与论坛。</strong>如果您参与联想的博客或论坛，应知晓您在博客或论坛中提供的信息可能会被可以访问该博客、论坛或聊天室的联想内部或外部的其他人广泛使用，只要您不删除共享信息，有关信息会一直留存在公共领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公共领域保存。因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。另外，请注意各个博客、论坛和聊天室可能是由联想以外的其他组织主办和/或可能有其他的规则和条件。每个参与者在博客、论坛或聊天室发表的意见是他们自己的意见，不应认为是反映了联想的意见。</li><li><strong>社交媒体功能和小部件。</strong>我们的一些网站包括社交媒体功能和链接，例如含有图标的社交媒体工具栏，这些图标链接到联想在特定网站、App上的内容（例如 微博、微信上的联想公众号）和社交媒体链接的服务可让您选择将您在本网站上的活动信息发布到您的个人资料页面，以便与您网络中的其他人共享。这些功能可能会收集您的 IP 地址以及关于您正在访问我们网站上的哪个页面的信息，并且可能会设置 cookie 来让该功能正常运行。您与这些功能的互动同时受提供功能的社交媒体公司的隐私政策管控。</li><li><strong>单点登录。</strong>您可以使用登录服务（例如 Facebook Connect 或 Open ID 提供商）来登录到我们网站的某些区域。这些服务将会验证您的身份；为您提供与我们分享某些个人信息（例如您的姓名和电子邮件地址）的选项，以及预先填写我们的注册表单。单点登录服务可让您选择将您在本网站上的活动信息发布到您的个人资料页面，以便与您网络中的其他人共享。</li><li><strong>框架与提供技术支持网站。</strong>我们的一些页面使用框架技术来处理来自供应商或合作伙伴的内容，同时维持我们的站点的外观。另外，某些联想品牌的网站可能是由供应商或合作伙伴运营，可能标有“提供技术支持”徽标。同时，部分联想网站上的链接可能会指引或跳转至第三方网站界面。请注意，此类网站可能由我们的供应商或合作伙伴运营，其隐私实践不受限于本隐私政策。</li><li><strong>兼并与收购。</strong>有些时候，出于战略或其他业务原因，联想可能会决定在一些国家或地区出售、收购、兼并或以其他方式重组业务。我们将会通过电子邮件及/或在我们的网站上的显著位置发出通知，告知您的个人信息的所有权或用途的任何变化以及关于您的个人信息您可能拥有的任何选择。这种交易可能会涉及向潜在或实际的买方披露个人信息或者从卖方获得个人信息。我们会要求任何在兼并与收购中获取您的个人信息的第三方按照不低于本隐私声明的要求确保您的个人信息保密与安全。</li><li><strong>其他来源。</strong>除了上述情况，还可能会出现要求我们向上述以外的其他方（包括但不限于法律顾问或债务托收代理）披露您的个人信息的情况。我们会要求任何依法合理获取您的个人信息的其他第三方按照不低于本隐私声明的要求确保您的个人信息保密与安全。</li></ul></div>
                        <div className="line3">四、个人信息的存储地点</div>
                        <div className="line6"><ul><li>原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。 联想是一个全球性组织，其法律实体、业务流程、管理结构和技术系统遍布全球。因此，在法律允许的情况下，我们可能会在联想内部（包括子公司、关联方和母公司）或者与我们的供应商和业务合作伙伴分享您的个人信息，并且可能会将信息转移到我们开展业务的其他国家或地区。无论您的信息被转移到哪里和存放在哪里，我们的隐私和安全做法旨在为您的个人信息提供全球性保护。您理解并同意，我们为上述目的向境外传输或分享您的个人信息。 我们会在数据跨境传输前按照国家网信部门会同国务院有关部门制定的办法和相关标准进行安全评估，并符合其要求。</li><li><p>除了在本政策中载明的隐私做法之外，联想还针对在欧盟境内的联想集团公司和其他地方的联想集团公司之间的内部转移制定了一套“有约束力的公司规则”。这些规则经某些欧盟数据保护当局批准，是联想充分保护其处理之个人信息的承诺，无论这些信息存放于何处。完整的规则可以在此处找到。欲了解额外的信息，请联系【privacy@lenovo.com】</p></li></ul></div>
                        <div className="line3">推广应用</div>
                        <div className="line6"><ul><li>您在某些联想网站上向联想提供的信息还可能会被联想及选定的第三方用于推广目的。但是在使用之前，您将有权选择是否允许我们以该方式使用您的信息。</li></ul></div>
                        <div className="line3">五、Cookie、网络信标、和相关技术</div>
                        <div className="line6"><ul><li>和大多数网站一样，我们会自动收集一些信息并存储在日志文件中。我们有时候会收集关于访客在访问我们的网站期间的行为的信息，以帮助我们提供更好的客户服务、改善我们的网站体验的质量或者定制广告内容。</li><li>例如，我们会跟踪访客是从哪个域名前来访问我们的网站，我们也会衡量访客在联想网站上的活动，但是我们在执行上述操作时不会实际识别任何访客的身份（我们在下文中将此类信息称为“不可识别身份的信息”）。联想或其技术服务供应商可能会使用此类数据来分析趋势和统计资料，以改进我们的网站以及提供有针对性的广告。</li><li><strong>点击流。</strong>我们在交易中向您收集个人信息时，我们可能会以不可识别身份的格式提取有关该交易的一些信息并将这些信息与其他不可识别身份的信息结合在一起。这些信息有时称为“点击流”。此类信息仅在汇总层面使用和分析，以帮助我们了解趋势和模式。此类信息不会在个人层面查看。若您不希望以这种方式使用您的个人信息，可以通过禁用Cookie来实现，具体方式见下文“Cookie”一节。</li><li><strong>cookie。</strong>为了提供定制的网站体验，联想可能会使用 cookie，例如 Google Analytics 和 DoubleClick cookie，以存储和帮助跟踪关于您的信息。cookie 是从网络服务器发送到您的浏览器并存储在您的计算机硬盘上的小块数据。联想使用 cookie 来帮助提醒我们您是谁并在您访问期间帮助您浏览我们的网站。cookie 使我们能够为您保存密码和偏好，使得您无需在每次访问时都要重新输入。我们还使用 cookie 来确定基于兴趣的相关广告，以更好地服务用户。</li><li>联想还可能会使用 cookie 来衡量流量模式、您访问了联想网站的哪些区域以及您的访问模式。联想可能会使用此类信息来了解我们的用户如何浏览我们的网站以及确定常见的流量模式，包括用户来自哪个网站。我们使用此类信息来简化网站浏览、进行产品推荐以及帮助设计我们的网站以让您的体验更高效、更愉悦。使用 cookie 是相当标准的行为。我们不会将 Cookie 用于本政策所述目的之外的任何用途。有关Cookie的详情，请参见AboutCookies.org。</li><li>大多数浏览器最初设置为接受 cookie。但是，如果您倾向于不存储 cookie，您可以选择：</li><li><ul><li>不使用我们的网站</li><li>将浏览器设置为在收到 cookie 时通知您</li><li>将浏览器设置为拒绝接受 cookie</li><li>在访问我们的网站后删除 cookie</li><li>使用浏览器的无痕浏览设置（例如，在 Chrome 中称为 “Incognito”，在 Internet Explorer 称为 “InPrivate”，在 Firefox 和 Safari 中等浏览器中称为 “Private Browsing”）来浏览我们的网站。</li></ul></li><li>大部分网络浏览器都设有阻止 Cookie 的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。</li><li>如果您不知道如何控制或删除 cookie，或者希望不接收基于您的浏览历史记录的某些有针对性的广告，建议您访问 http://www.networkadvertising.org/choices/、www.aboutads.info 或 www.youronlinechoices.eu，了解详细的指导，包括选择退出说明。</li><li>如果您想选择退出 Google Analytics for Display Advertisers 和/或选择退出定制的 Google Display Network，可以访问 Google 的 Ads Preferences Manager 来选择退出。您也可以利用 Google Analytics Opt-out Browser Add-on 来选择退出 Google Analytics。关于如何在您的产品或移动设备的浏览器上执行此操作的信息，请参阅您浏览器或移动设备的帮助菜单或产品手册。</li><li>本地存储对象。另外，我们还可能会使用 Flash cookie 和 HTML5 等本地存储对象 (LSO) 来存储内容信息和偏好。根据您的网络浏览活动在我们的网站上提供某些功能或显示广告的供应商和合作伙伴也会使用 HTML5 等 LSO 来收集和存储信息。各种浏览器可能会提供各自的管理工具来删除 HMTM5 LSO。</li><li>在线广告。联想也可能会委托第三方公司（例如 Google Analytics for Display Advertisers、Google Display Network Impression Reporting、DoubleClick Campaign Manager 以及 Google Analytics Demographic and Interest Reporting）协助提供服务，以帮助我们了解您对我们的网站和产品的使用情况，以及投放和管理基于兴趣的广告。为提供这些服务，第三方公司可能会收集您的浏览活动信息或者通过 cookie之类的技术发送的信息，例如您的 IP 地址（关于如何控制这些 cookie 的信息，请参见上文 “Cookie” 一节）。</li><li>这些信息可能会用于衡量网站趋势以及在浏览网站（包括非联想网站）时投放联想产品广告。这些广告是基于您对联想网站的访问情况投放的。联想及其服务供应商使用 cookie 来报告、分析您的广告印象、对广告服务使用情况以及广告印象和广告服务的互动如何与访问联想网站发生联系。</li><li>如果您不想此类信息用于为您提供基于兴趣的广告，可以控制Cookie信息或联系【privacy@lenovo.com】选择退出。但请注意，您仍将继续接收一般广告。</li><li>Adobe Marketing Cloud Device Co-Op。某些联想网站参与 Adobe Marketing Cloud Device Cooperative，以更好地了解您是如何在您使用的各种设备上使用我们的某些网站和应用程序的，以及交付定制的促销。了解更多关于 Adobe 如何实施此计划以及您可以如何退出此计划的信息。</li><li>网络信标和其他技术。一些联想网站还使用网络信标或 Java 脚本和电子标签等其他技术来更好地定制这些网站，以提供更好的客户服务。这些技术可能会在联想网站的多个页面上使用。访客访问这些页面时，将会生成一条不可识别身份的访问通知。我们或我们的供应商可能会处理该访问通知。这些网络信标通常与 cookie 结合工作。如果您关闭 cookie，网络信标和其他技术将仍然会检测对这些页面的访问，但它们生成的通知不能与其他不可识别身份的 cookie 信息关联，因而会被忽视。</li><li>个性化 URL 链接。我们有时可能会针对某些访客个性化和定制网站。如果您访问这些网站，您会发现它们是经过定制的，它们含有我们基于您以前与联想的互动以及您提供给我们的信息认为您可能感兴趣的产品及/或服务的参考。在您访问这些网站时，我们可能会收集关于您的访问的信息，以更好地按您的兴趣定制站点。访问这些网站的邀请形式包括但不限于电子邮件中的个性化 URL、网站注册页面上的通知或者您登录到某个网站时的响应。</li><li>如果您选择访问这些网站之一，联想将会收集关于您的访问的信息并使此类信息与关于您和您与联想的关系的其他信息关联。如果您不希望以此方式使用您的信息，请勿访问这些网站或从我们的寄信名单中退订。</li></ul></div>
                        <div className="line3">六、个人信息保存时限</div>
                        <div className="line6"><ul><li>我们将只在您的帐户有效期内或者在为您提供服务所需的期限内保留您的个人信息。我们还将在为遵守适用的法律义务、解决争议以及执行协议而必要的期限内保留您的个人信息。</li></ul></div>
                        <div className="line3">七、个人信息安全</div>
                        <div className="line6"><ul><li>在信息传输期间以及在收到信息后，联想会实施适当的技术/组织措施和流程来保护您的个人信息以及维持其质量。例如，在传输敏感信息（例如信用卡号码）时，我们使用加密来帮助保持信息的安全。</li><li>但是，请注意，通过互联网传输的任何数据都不能保证是百分之百安全的。因此，虽然我们会采取恰当的措施来保护您的个人信息，但联想无法确定或保证您提供给我们或从我们的网站获取的信息的安全性，因此在使用我们的网站时，您应自行承担风险。有关如何向联想和联想信息安全团队报告安全问题、事项或可能的事件的信息，可随时联系【privacy@lenovo.com】。如发生个人信息安全事件，我们将按照法律法规的要求，及时向您告知并向监管部门报告。</li></ul></div>
                        <div className="line3">八、儿童隐私保护</div>
                        <div className="line6"><ul><li>若您未满14岁，您可以浏览联想的网站，但联想运营或者代表联想运营的网站旨在供年满 14 岁以上的人使用。联想不会主动寻求收集关于未满 14 岁的儿童的信息。如您的监护人或父母沒有阅读并了解本站內容并同意您提供个人信息，未满 14 岁的用户不应在联想网站上提供或公布任何信息。</li><li>如果未满 14岁的儿童向联想的网站提交个人信息，我们一旦发现此类信息是由未满 14 岁的儿童提供且没有其监护人或父母的同意，我们就会立即删除此类信息且不会将此类信息用于任何目的。联想鼓励家长主动监督子女使用互联网并告知他们在互联网上提供关于自己的信息的潜在危险。</li></ul></div>
                        <div className="line3">九、您的数据控制权</div>
                        <div className="line6"><ul><li>适用的数据保护法律可能会赋予您控制我们使用和处理您的个人信息的权利。该等权利可能包括：(i) 要求访问和复制您的个人信息，(ii) 要求更正或删除您的部分个人信息；(iii) 限制或拒绝处理您的个人信息； (iv) 数据可携性；以及（v）注销您的Lenovo ID。在我们征得您同意而使用您的个人信息的情况下，您也有权随时撤销您的同意，但这并不影响我们在您撤销您的同意之前使用您的个人信息。</li><li>如要行使您的任何权利，请通过登录您的Lenovo ID进行账户查阅及更改、在有关的文件中勾选相应的选项（如在邮件中选择退订消息）或通过【privacy@lenovo.com】联系我们。我们将会按照适用的数据保护法律考虑和处理任何此等请求，并且我们可能会要求您核实您的身份，以帮助我们有效地回应您的请求。我们将会在【三十】天内作出答复。</li><li>您还有权随时通过【privacy@lenovo.com】向我们提出问题或投诉，或直接相关的政府部门提出问题或投诉。</li></ul></div>
                        <div className="line3">十、联系我们</div>
                        <div className="line6"><ul><li>如果您对本隐私政策有疑问，可通过下述方式联系联想：发送电子邮件至【privacy@lenovo.com】或发送邮政邮件至联想，收件地址：北京市海淀区西北旺东路10号院2号楼法务部，邮编：100094.</li></ul></div>
                        </div>
                            </Modal>
            
                        
                         <div className="ant-row ant-form-item">
                            <div className="ant-form-item-label ant-col-xs-24 ant-col-sm-8">
                                
                            </div>
                            <div class="ant-form-item-control-wrapper ant-col-xs-24 ant-col-sm-16" style={{lineHeight: "36px"}}>
                            <Checkbox checked={this.state.checked} onChange={(e) => this.checkChange(e.target.checked)}><FormattedMessage id="intl-checkTip"/> </Checkbox><a onClick={this.openxy.bind(this)}><FormattedMessage id="intl-PrivacyPolicy"/></a>
                            </div>
                        </div>

                    {/* <dl>
                        <dt>
                            <em>*</em><span><FormattedMessage id='intl-agree-lenovoService'/>
                            <a
                                style={{position: "relative", zIndex: 999, marginLeft: "10px"}}
                                onClick={this.showModal}>
                             Terms and Conditions
                            </a> </span>
                            <Modal
                                title="Basic Modal"
                                visible={this.state.visible}
                                onOk={this.handleOk}
                                onCancel={this.handleCancel}
                            >
                                <p>Some contents...</p>
                                <p>Some contents...</p>
                                <p>Some contents...</p>
                            </Modal>


                            <FormItem
                                {...formItemLayoutA}
                                help=""
                            >
                                {getFieldDecorator('radioA', {
                                    initialValue: historyDate && historyDate.radioA,
                                })(
                                    <RadioGroup>
                                        <Radio style={radioStyle} value={1}>
                                            <FormattedMessage
                                                id="intl-Activities3-I agree"
                                            /></Radio>
                                        <Radio style={radioStyle} value={5}>
                                            <FormattedMessage
                                                id="intl-Activities3-I disagree"
                                            /></Radio>
                                    </RadioGroup>
                                )}
                            </FormItem>
                        </dt>
                        <dt>
                            <em>*</em><FormattedMessage id='intl-agree-personalInfo'/>
                            <FormItem
                                {...formItemLayoutA}
                                help=""
                            >
                                {getFieldDecorator('radioB', {
                                    initialValue: historyDate && historyDate.radioB,
                                })(
                                    <RadioGroup>
                                        <Radio style={radioStyle} value={2}>
                                            <FormattedMessage
                                                id="intl-Activities3-I agree"
                                            /></Radio>
                                        <Radio style={radioStyle} value={6}>
                                            <FormattedMessage
                                                id="intl-Activities3-I disagree"
                                            /></Radio>
                                    </RadioGroup>
                                )}
                            </FormItem>
                        </dt>
                        <dt>
                            <em>*</em><FormattedMessage id='intl-agree-requiredPersonalInfo'/>

                            <FormItem
                                {...formItemLayoutA}
                                help=""
                            >
                                {getFieldDecorator('radioC', {
                                    initialValue: historyDate && historyDate.radioC,
                                })(
                                    <RadioGroup>
                                        <Radio style={radioStyle} value={3}>
                                            <FormattedMessage
                                                id="intl-Activities3-I agree"
                                            /></Radio>
                                        <Radio style={radioStyle} value={7}>
                                            <FormattedMessage
                                                id="intl-Activities3-I disagree"
                                            /></Radio>
                                    </RadioGroup>
                                )}
                            </FormItem>


                        </dt>
                        <dt>
                            <em>*</em><FormattedMessage id='intl-agree-optionalPersonalInfo'/>
                            <a
                                style={{position: "relative", zIndex: 999, marginLeft: "10px"}}
                                onClick={this.showModal}>
                                Privacy Policy
                            </a>

                            <FormItem
                                {...formItemLayoutA}
                                help=""
                            >
                                {getFieldDecorator('radioD', {
                                    initialValue: historyDate && historyDate.radioD,
                                })(
                                    <RadioGroup>
                                        <Radio style={radioStyle} value={4}>
                                            <FormattedMessage
                                                id="intl-Activities3-I agree"
                                            /></Radio>
                                        <Radio style={radioStyle} value={8}>
                                            <FormattedMessage
                                                id="intl-Activities3-I disagree"
                                            /></Radio>
                                    </RadioGroup>
                                )}
                            </FormItem>
                        </dt>
                    </dl> */}
                {/* </div> */}
                {/*上一步，下一步*/}
                <FormItem style={{textAlign: "center"}}>
                    <Button htmlType="submit"
                            style={{textAlign: "center", marginRight: "30px"}} onClick={this.handleBack}>
                        <FormattedMessage
                            id="intl-Activities-Previous"
                        />
                    </Button>
                    <Button type="primary" htmlType="submit"
                    className="btn-color-vi2"
                            style={{textAlign: "center"}} disabled={this.state.flag} onClick={this.handleNext}>
                        <FormattedMessage
                            id="intl-Activities-Next"
                        />
                    </Button>
                </FormItem>
            </Form>


        );
    }
}

const WrappedRegistrationForm = Form.create()(RegistrationForm);

class Activities3 extends React.Component {
    render() {
        return (<div className="insideDiv">
            <div className="center">
                {/*步骤条*/}
                <ul className="timeLine">
                    <li className="active">
                        <i>1</i>
                        <p><FormattedMessage
                            id="intl-Activities-NumberOfVisitors"
                        /></p>
                    </li>
                    <li className="active">
                        <i>2</i>
                        <p><FormattedMessage
                            id="intl-Activities-NumberOfVisitors2"
                        /></p>
                    </li>
                    <li className="active">
                        <i>3</i>
                        <p><FormattedMessage
                            id="intl-Activities-Datails"
                        /></p>
                    </li>
                    <li>
                        <i>4</i>
                        <p><FormattedMessage
                            id="intl-Activities-Confirmation"
                        /></p>
                    </li>
                </ul>
                {/*文字*/}
                <dl className="applyDl">
                    <dt><FormattedMessage
                        id="intl-Activities3-details"
                    /></dt>
                </dl>
                <h4 className="applyTitle"><FormattedMessage
                    id="intl-Activities3-Information"
                /></h4>
                <WrappedRegistrationForm {...this.props}/>
            </div>
        </div>)
    }
}

connect(state => ({...state}), actions)(RegistrationForm);
export default connect(state => ({...state,...state.Activities3, ...state.Language, ...state.Home}), {...actions,...actions.Activities3, ...actions.Language, ...actions.Home})(Activities3)





// WEBPACK FOOTER //
// ./src/containers/Activities/Activities3.js